export default __webpack_public_path__ + "static/media/blueflag.5aaaadb5.png";